<div class="row topRowMargins headerStyle">

    <div class="col-lg-12">

       Vault To Vault Migration 

    </div>

</div>

<div style="margin-top: 40px;">
    <form>
        <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-8" style="text-align: center;">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCselectschedule">Select Source Vault DNS</mat-label>
                    <mat-select [ngModelOptions]="{standalone: true}" [(ngModel)]="vaultDNS" ngDefaultControl >
                      <mat-option>None</mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            <!-- button color is defined in scss for now because ts is not added -->
            <div class="verifybtnsection col-lg-2" style="text-align: center;">
                <button (click)="verify()" i18n="@@TMRunButton" type="button" [style.background-color]="backgroundColorButton"
                class="verifybtn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.background-color]="backgroundColorButton">Verify</button>
            </div>
            <div class="col-lg-1"></div>
        </div>

        <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="checkboxes col-lg-8">
                <mat-label i18n="@@RCselectschedule">Select the Obejects to be Transfered:</mat-label><br>
                <mat-checkbox>Library</mat-checkbox><br>
                <mat-checkbox>Study</mat-checkbox><br>
                <mat-checkbox>E2B</mat-checkbox><br>
                <mat-checkbox>NonE2B</mat-checkbox><br>
                <mat-checkbox>Attachments</mat-checkbox><br>
            </div>
            <div class="col-lg-1"></div>
        </div>

        <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-9">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Data Transfer Log</mat-label>
                  <input class="input" matInput type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="dataTransfer" ngDefaultControl>
                </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </form>
    <div class="row topRowMargins">
        <div class="col-lg-2 btnsection" style="text-align: center;">
            <!-- button color is defined in scss for now because ts is not added -->
            <button  i18n="@@TMRunButton" type="button" [style.background-color]="backgroundColorButton"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem; background-color:skyblue;" [style.background-color]="backgroundColorButton" id="114">Initiate Transfer</button>
        </div>
    </div>
</div>